import {
  ADJUSTED_EBITDA_ALIAS,
  AMORTIZATION_EXPENSE_ALIAS,
  DEPRECIATION_EXPENSE_ALIAS,
  EBIT_ALIAS,
  EBITDA_ALIAS,
  GROSS_PROFIT_ALIAS,
  INCOME_TAXES_ALIAS,
  INTEREST_EXPENSE_ALIAS,
  NET_INCOME_ALIAS,
  OPERATING_EXPENSES_ALIAS,
  OTHER_EXPENSE_ALIAS,
  PRETAX_INCOME_ALIAS,
  TOTAL_REVENUE_ALIAS,
  TOTAL_SALES_COST_ALIAS,
} from 'common/constants/financials';
import { FinancialStatementPeriod } from 'common/types/financials';
import hasReportedValue from './hasReportedValue';
import trimBlankExportColumns from './trimBlankExportColumns';

// Every value-bearing row of the income statement row config, in row order.
// Keep in sync with pages/Financials/income-statement/data/rowConfig.
const INCOME_STATEMENT_VALUE_ALIASES = [
  TOTAL_REVENUE_ALIAS,
  TOTAL_SALES_COST_ALIAS,
  GROSS_PROFIT_ALIAS,
  OPERATING_EXPENSES_ALIAS,
  EBITDA_ALIAS,
  ADJUSTED_EBITDA_ALIAS,
  DEPRECIATION_EXPENSE_ALIAS,
  AMORTIZATION_EXPENSE_ALIAS,
  EBIT_ALIAS,
  INTEREST_EXPENSE_ALIAS,
  OTHER_EXPENSE_ALIAS,
  PRETAX_INCOME_ALIAS,
  INCOME_TAXES_ALIAS,
  NET_INCOME_ALIAS,
] as const;

const hasIncomeStatementValue = (column: FinancialStatementPeriod) => {
  const incomeStatement = column.income_statement;

  if (!incomeStatement) {
    return false;
  }

  return INCOME_STATEMENT_VALUE_ALIASES.some(alias => hasReportedValue(incomeStatement[alias]));
};

/**
 * Trims blank projection years off the end of the income statement.
 *
 * Historical years are never removed, but they still anchor the populated range — which is
 * what keeps a blank projection sitting between two populated years on the page.
 */
const trimBlankIncomeStatementColumns = (columns: FinancialStatementPeriod[]) =>
  trimBlankExportColumns({
    columns,
    hasValue: hasIncomeStatementValue,
    isTrimmable: column => Boolean(column.isProjectedYear),
  });

export default trimBlankIncomeStatementColumns;
